<template>
<section class="polar-contour-wrapper">
  <section class="polar-contour-chart-wrapper">
    <canvas :ref="canvasRef" class="polar-contour-chart" />

    <div
      v-if="contourOpts"
      class="download-btn"
      @click="handleExportChart"
    ><i class="el-icon-download"></i></div>
  </section>

  <section v-if="contourOpts" class="contour-settings-wrapper">
    <section class="contour-settings-header">
      <span class="contour-settings-interval-label">分段</span>
      <el-input v-model="contourOpts.interval" type="number" size="mini" class="contour-settings-interval-input" />
      <el-button type="success" size="mini" @click="handleSetInterval">分段</el-button>
    </section>

    <section class="contour-settings-body">
      <div
        v-for="(threshold, index) in contourOpts.thresholdOpts"
        :key="index"
        class="contour-settings-item"
      >
        <span class="contour-settings-item-label">第{{index + 1}}段</span>
        <el-input
          v-model="threshold[1]"
          type="color"
          size="mini"
          class="contour-settings-item-color-input"
        />
        <el-input
          v-model="threshold[0]"
          type="number"
          size="mini"
          class="contour-settings-item-value-input"
        />
      </div>
    </section>

    <section class="contour-settings-foot">
      <el-button type="orange" size="mini" @click="handleChangeContourParams">确定</el-button>
      <el-button size="mini" @click="handleCancelContourParams">取消</el-button>
    </section>
  </section>
</section>
</template>

<script>
import Util from './util'

export default {
  name: 'PolarContour',
  props: {
    /**
     * 数据列表
     */
    dataList: {
      required: true,
      type: Array
    },

    /**
     * 视图尺寸变化事件名
     */
    windowResizeEventKey: String,

    /**
     * 坐标空间的类型(0: [r, θ, z]， 1: [x, y, z])
     */
    coordinateType: {
      type: Number,
      default: 0
    },

    /**
     * 数据单位
     */
    unit: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      contourOpts: null
    }
  },
  computed: {
    canvasRef: () => 'canvas'
  },
  methods: {
    getCanvas () {
      return this.$refs[this.canvasRef]
    },
    setChartSize () {
      Util.setChartSize(this.getCanvas(), this.contourOpts, this.opts, this.unit)
    },
    draw () {
      let {vertices, opts} = this

      this.setChartSize()
      Util.draw(this.getCanvas(), this.coordinateType, vertices, opts, this.unit)

      // if (this.coordinateType === 0) {
      //   vertices = Util.convertToXYZ(vertices, opts)
      // }
    },
    onDataChanged (dataList) {
      let contourOpts = Util.getContourOpts(this.vertices = dataList)
      let opts = this.opts = JSON.parse(JSON.stringify(contourOpts))

      this.contourOpts = {
        interval: contourOpts.interval,
        thresholdOpts: contourOpts.thresholdOpts
      }

      Util.setMaxVal(dataList, opts)
      this.draw()
    },
    onWindowSizeChange () {
      let clearWindowResizeTimer = this.clearWindowResizeTimer

      clearWindowResizeTimer && clearWindowResizeTimer()

      let timer = setTimeout(() => {
        this.draw()
      }, 200)

      this.clearWindowResizeTimer = () => clearTimeout(timer)
    },
    clear () {
      Util.clearCanvas(this.getCanvas())
      this.contourOpts = null
      this.vertices = null
    },
    handleSetInterval () {
      let {opts, contourOpts} = this

      if (contourOpts) {
        contourOpts.thresholdOpts = Util.getThresholdOpts(opts.minZ, opts.maxZ, parseInt(contourOpts.interval))
      }
    },
    handleChangeContourParams () {
      let contourOpts = this.contourOpts
      this.opts.interval = parseInt(contourOpts.interval)
      this.opts.thresholdOpts = JSON.parse(JSON.stringify(contourOpts.thresholdOpts.map(([threshold, color]) => [parseFloat(threshold), color])))
      this.draw()
    },
    handleCancelContourParams () {
      let {contourOpts, opts} = this
      contourOpts.thresholdOpts = JSON.parse(JSON.stringify(opts.thresholdOpts))
      contourOpts.interval = opts.interval
    },
    handleExportChart () {
      let canvas = this.getCanvas()
      canvas.toBlob(blob => {
        // let site = this.site
        // let query = this.query
        // let filename = `${site.label}_${query.beginTime.replace(/[-:\s]/g, '')}_${query.endTime.replace(/[-:\s]/g, '')}.png`
        let filename = '污染物玫瑰图.png'

        if (navigator.msSaveOrOpenBlob) {
          navigator.msSaveOrOpenBlob(blob, filename)
        } else {
          let url = URL.createObjectURL(blob)
          let link = document.createElement('a')
          link.download = filename
          link.href = url
          link.click()
          URL.revokeObjectURL(url)
        }
      })
    }
  },
  watch: {
    dataList (dataList) {
      setTimeout(() => {
        this.onDataChanged(dataList)
      }, 0)
    }
  },
  created () {
    this.$nextTick(() => {
      let eb = this.$eventBus
      let {windowResizeEventKey} = this

      if (windowResizeEventKey) {
        eb.on(windowResizeEventKey, this.onWindowSizeChange)
      }
    })
  },
  mounted () {
    let {dataList} = this

    if (dataList.length > 0) {
      setTimeout(() => {
        this.onDataChanged(dataList)
      }, 0)
    }
  },
  beforeDestroy () {
    let eb = this.$eventBus
    let {windowResizeEventKey, clearWindowResizeTimer} = this

    if (windowResizeEventKey) {
      eb.off(windowResizeEventKey, this.onWindowSizeChange)
    }

    clearWindowResizeTimer && clearWindowResizeTimer()
  }
}
</script>

<style lang="scss" scoped>
.polar-contour-wrapper {
  $SETTINGS-WRAPPER-WIDTH: 250px;

  position: relative;
  width: 100%;
  height: 100%;
  padding-right: $SETTINGS-WRAPPER-WIDTH;

  > .polar-contour-chart-wrapper {
    position: relative;
    width: 100%;
    height: 100%;

    > .polar-contour-chart {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      margin: auto;
    }

    .download-btn {
      position: absolute;
      right: 10px;
      top: 5px;
      z-index: 1;
      color: #666;
      cursor: pointer;
    }
  }

  > .contour-settings-wrapper {
    $HEADER-HEIGHT: 44px;
    $FOOTER-HEIGHT: 40px;

    position: absolute;
    top: 0;
    right: 0;
    width: $SETTINGS-WRAPPER-WIDTH;
    height: 100%;
    padding: $HEADER-HEIGHT 0 $FOOTER-HEIGHT 0;
    box-shadow: -1px 0 0 0 #E4F0FF;

    > .contour-settings- {
      &header {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: $HEADER-HEIGHT;
        padding: 8px 0;

        > * {
          float: left;
        }
      }

      &body {
        width: 100%;
        height: 100%;
        overflow: auto;
      }

      &foot {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: $FOOTER-HEIGHT;
        padding: 6px 1em;
        text-align: right;

        > * {
          vertical-align: top;
        }
      }
    }

    .contour-settings-interval-label {
      font-size: .7rem;
      display: inline-block;
      font-weight: bolder;
      width: 58px;
      line-height: 28px;
      text-align: center;
    }

    .contour-settings-interval-input {
      width: 100px;
      margin: 0 8px 0 0;
    }

    .contour-settings-item {
      float: left;
      width: 100%;
      line-height: 28px;
      margin: 8px 0;
      /*padding: 0 8px;*/

      > * {
        float: left;
      }

      .contour-settings-item- {
        &label {
          font: {
            size: .7em;
            weight: bolder;
          };
          width: 58px;
          padding-right: 8px;
          text-align: right;
        }

        &color-input {
          width: 28px;
          height: 28px;

          /deep/ .el-input__inner {
            padding: 0;
            cursor: pointer;
          }
        }

        &value-input {
          width: 126px;
          height: 28px;
          margin-left: 8px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PolarContour/index.vue